export const POSSIBLE_LABEL_KEYS = [
  'ten_cqt',
  'ten_qg',
  'ten_tinh',
  'ten_quan',
  'ten_bp',
  'ten_nt',
  'ten_cp',
  'ten_nh',
  'ten_kich_co',
  'ten_dvt',
  'ten_dv',
  'ten_vu_viec',
  'ten_dc',
  'ten_lo',
  'ten_phan_nhom',
  'name',
  'full_name',
  'customer_name'
];
